
import { useTranslation } from 'react-i18next';

export default function Benefits() {
  const { t } = useTranslation('about');

  const benefits = [
    {
      icon: 'ri-global-line',
      title: t('benefits.globalNetwork'),
      description: t('benefits.globalNetworkDesc')
    },
    {
      icon: 'ri-award-line',
      title: t('benefits.expertise'),
      description: t('benefits.expertiseDesc')
    },
    {
      icon: 'ri-cpu-line',
      title: t('benefits.technology'),
      description: t('benefits.technologyDesc')
    },
    {
      icon: 'ri-shield-check-line',
      title: t('benefits.compliance'),
      description: t('benefits.complianceDesc')
    },
    {
      icon: 'ri-customer-service-2-line',
      title: t('benefits.support'),
      description: t('benefits.supportDesc')
    },
    {
      icon: 'ri-leaf-line',
      title: t('benefits.sustainability'),
      description: t('benefits.sustainabilityDesc')
    }
  ];

  return (
    <section className="py-20 bg-[#F5F7FA]">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl lg:text-4xl font-bold text-[#0D1B2A] mb-4 tracking-tight">
            {t('benefits.title')}
          </h2>
          <p className="text-xl text-[#394B59] max-w-3xl mx-auto leading-relaxed">
            {t('benefits.subtitle')}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {benefits.map((benefit, index) => (
            <div key={index} className="bg-white rounded-2xl p-8 shadow-sm hover:shadow-lg transition-all duration-300">
              <div className="w-16 h-16 bg-[#0D1B2A] rounded-xl flex items-center justify-center mb-6">
                <i className={`${benefit.icon} text-2xl text-white`}></i>
              </div>
              <h3 className="text-xl font-semibold text-[#0D1B2A] mb-4">
                {benefit.title}
              </h3>
              <p className="text-[#394B59] leading-relaxed">
                {benefit.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
